import React from "react";
import moment from "moment";

class Date extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div class="conversation-message-date">
                <div class="date-content">
                    { moment( this.props.date ).format( "dddd, DD-MMM YYYY" ) }
                </div>
            </div>
        );
    }
}

export default Date;